// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: black;
}

.arrow {
  position: absolute;
  width: 0;
  height: 0;
  border: solid transparent;
}

.arrow.red { border-color: red; }
.arrow.yellow { border-color: yellow; }
.arrow.green { border-color: green; }

.arrow.top-left {
  top: 0;
  left: 0;
  border-width: 50vh 50vw 0 0;
  border-top-color: currentColor;
}

.arrow.top-right {
  top: 0;
  right: 0;
  border-width: 50vh 0 0 50vw;
  border-top-color: currentColor;
}

.arrow.bottom-left {
  bottom: 0;
  left: 0;
  border-width: 0 50vw 50vh 0;
  border-bottom-color: currentColor;
}

.arrow.bottom-right {
  bottom: 0;
  right: 0;
  border-width: 0 0 50vh 50vw;
  border-bottom-color: currentColor;
}

.arrow.middle-left {
  top: 25%;
  left: 0;
  border-width: 25vh 50vw 25vh 0;
  border-right-color: currentColor;
}

.arrow.middle-right {
  top: 25%;
  right: 0;
  border-width: 25vh 0 25vh 50vw;
  border-left-color: currentColor;
}

/* Container for arrow image, responsible for size and position */
.arrow-img-container {
  position: absolute;
  width: 50vw;
  height: 50vh;
  padding: 32px;
  display: flex;
  align-items: center;
  justify-content: flex-start; /* default: left */
  pointer-events: none;
}

/* For right-aligned arrows */
.arrow-img-container.top-right,
.arrow-img-container.bottom-right,
.arrow-img-container.middle-right {
  justify-content: flex-end;
}

.arrow-img-container.top-left {
  top: 0;
  left: 0;
}
.arrow-img-container.top-right {
  top: 0;
  right: 0;
}
.arrow-img-container.bottom-left {
  bottom: 0;
  left: 0;
}
.arrow-img-container.bottom-right {
  bottom: 0;
  right: 0;
}
.arrow-img-container.middle-left {
  top: 25vh;
  left: 0;
}
.arrow-img-container.middle-right {
  top: 25vh;
  right: 0;
}

/* The image itself fills the container */
.arrow-img {
  width: auto;
  height: 100%;
  aspect-ratio: 1 / 1;
  max-width: 100%;
  object-fit: contain;
  pointer-events: none;
}

.arrow-img.red {
  filter: drop-shadow(0 0 0 red) brightness(0) saturate(100%) invert(14%) sepia(99%) saturate(7492%) hue-rotate(359deg) brightness(97%) contrast(119%);
}
.arrow-img.yellow {
  filter: drop-shadow(0 0 0 yellow) brightness(0) saturate(100%) invert(86%) sepia(99%) saturate(7492%) hue-rotate(359deg) brightness(97%) contrast(119%);
}
.arrow-img.green {
  filter: drop-shadow(0 0 0 green) brightness(0) saturate(100%) invert(46%) sepia(99%) saturate(7492%) hue-rotate(90deg) brightness(97%) contrast(119%);
}

/* Positioning for each direction (adjust as needed) */
.arrow-img.top-left {
  top: 0;
  left: 0;
  width: 50vw;
  height: 50vh;
}

.arrow-img.top-right {
  top: 0;
  right: 0;
  width: 50vw;
  height: 50vh;
}

.arrow-img.bottom-left {
  bottom: 0;
  left: 0;
  width: 50vw;
  height: 50vh;
}

.arrow-img.bottom-right {
  bottom: 0;
  right: 0;
  width: 50vw;
  height: 50vh;
}

.arrow-img.middle-left {
  top: 25vh;
  left: 0;
  width: 50vw;
  height: 50vh;
}

.arrow-img.middle-right {
  top: 25vh;
  right: 0;
  width: 50vw;
  height: 50vh;
}

.control-panel {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.8);
  padding: 1em;
  border-radius: 10px;
  text-align: center;
  z-index: 2;
}

.color-buttons .circle {
  width: 30px;
  height: 30px;
  margin: 0 5px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  margin-bottom: 8px;
}

.color-buttons .red { background: red; }
.color-buttons .yellow { background: yellow; }
.color-buttons .green { background: green; }
.color-buttons .gray { background: gray; }

.input-row input {
  width: 80px;
  margin: 0 5px;
  padding: 5px;
  font-size: 16px;
  margin-bottom: 8px;
}

.action-buttons button {
  font-size: 20px;
  margin: 0 5px;
  padding: 5px 10px;
  cursor: pointer;
}

.action-buttons .active {
  background-color: green;
  color: white;
}

.frame-row {
  display: flex;
  gap: 2rem;
  border: 2px solid #bbb;
  border-radius: 10px;
  padding: 1rem 2rem;
  background: #f5f5f5;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
}

.frame-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.frame-label {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.3rem;
}

.frame-value {
  font-size: 2rem;
  font-weight: bold;
  color: #222;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;;AAEA,aAAa,iBAAiB,EAAE;AAChC,gBAAgB,oBAAoB,EAAE;AACtC,eAAe,mBAAmB,EAAE;;AAEpC;EACE,MAAM;EACN,OAAO;EACP,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,OAAO;EACP,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,QAAQ;EACR,OAAO;EACP,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,2BAA2B,EAAE,kBAAkB;EAC/C,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,MAAM;EACN,OAAO;AACT;AACA;EACE,MAAM;EACN,QAAQ;AACV;AACA;EACE,SAAS;EACT,OAAO;AACT;AACA;EACE,SAAS;EACT,QAAQ;AACV;AACA;EACE,SAAS;EACT,OAAO;AACT;AACA;EACE,SAAS;EACT,QAAQ;AACV;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,oJAAoJ;AACtJ;AACA;EACE,uJAAuJ;AACzJ;AACA;EACE,qJAAqJ;AACvJ;;AAEA,sDAAsD;AACtD;EACE,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA,sBAAsB,eAAe,EAAE;AACvC,yBAAyB,kBAAkB,EAAE;AAC7C,wBAAwB,iBAAiB,EAAE;AAC3C,uBAAuB,gBAAgB,EAAE;;AAEzC;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb","sourcesContent":[".container {\n  position: relative;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n  background-color: black;\n}\n\n.arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border: solid transparent;\n}\n\n.arrow.red { border-color: red; }\n.arrow.yellow { border-color: yellow; }\n.arrow.green { border-color: green; }\n\n.arrow.top-left {\n  top: 0;\n  left: 0;\n  border-width: 50vh 50vw 0 0;\n  border-top-color: currentColor;\n}\n\n.arrow.top-right {\n  top: 0;\n  right: 0;\n  border-width: 50vh 0 0 50vw;\n  border-top-color: currentColor;\n}\n\n.arrow.bottom-left {\n  bottom: 0;\n  left: 0;\n  border-width: 0 50vw 50vh 0;\n  border-bottom-color: currentColor;\n}\n\n.arrow.bottom-right {\n  bottom: 0;\n  right: 0;\n  border-width: 0 0 50vh 50vw;\n  border-bottom-color: currentColor;\n}\n\n.arrow.middle-left {\n  top: 25%;\n  left: 0;\n  border-width: 25vh 50vw 25vh 0;\n  border-right-color: currentColor;\n}\n\n.arrow.middle-right {\n  top: 25%;\n  right: 0;\n  border-width: 25vh 0 25vh 50vw;\n  border-left-color: currentColor;\n}\n\n/* Container for arrow image, responsible for size and position */\n.arrow-img-container {\n  position: absolute;\n  width: 50vw;\n  height: 50vh;\n  padding: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start; /* default: left */\n  pointer-events: none;\n}\n\n/* For right-aligned arrows */\n.arrow-img-container.top-right,\n.arrow-img-container.bottom-right,\n.arrow-img-container.middle-right {\n  justify-content: flex-end;\n}\n\n.arrow-img-container.top-left {\n  top: 0;\n  left: 0;\n}\n.arrow-img-container.top-right {\n  top: 0;\n  right: 0;\n}\n.arrow-img-container.bottom-left {\n  bottom: 0;\n  left: 0;\n}\n.arrow-img-container.bottom-right {\n  bottom: 0;\n  right: 0;\n}\n.arrow-img-container.middle-left {\n  top: 25vh;\n  left: 0;\n}\n.arrow-img-container.middle-right {\n  top: 25vh;\n  right: 0;\n}\n\n/* The image itself fills the container */\n.arrow-img {\n  width: auto;\n  height: 100%;\n  aspect-ratio: 1 / 1;\n  max-width: 100%;\n  object-fit: contain;\n  pointer-events: none;\n}\n\n.arrow-img.red {\n  filter: drop-shadow(0 0 0 red) brightness(0) saturate(100%) invert(14%) sepia(99%) saturate(7492%) hue-rotate(359deg) brightness(97%) contrast(119%);\n}\n.arrow-img.yellow {\n  filter: drop-shadow(0 0 0 yellow) brightness(0) saturate(100%) invert(86%) sepia(99%) saturate(7492%) hue-rotate(359deg) brightness(97%) contrast(119%);\n}\n.arrow-img.green {\n  filter: drop-shadow(0 0 0 green) brightness(0) saturate(100%) invert(46%) sepia(99%) saturate(7492%) hue-rotate(90deg) brightness(97%) contrast(119%);\n}\n\n/* Positioning for each direction (adjust as needed) */\n.arrow-img.top-left {\n  top: 0;\n  left: 0;\n  width: 50vw;\n  height: 50vh;\n}\n\n.arrow-img.top-right {\n  top: 0;\n  right: 0;\n  width: 50vw;\n  height: 50vh;\n}\n\n.arrow-img.bottom-left {\n  bottom: 0;\n  left: 0;\n  width: 50vw;\n  height: 50vh;\n}\n\n.arrow-img.bottom-right {\n  bottom: 0;\n  right: 0;\n  width: 50vw;\n  height: 50vh;\n}\n\n.arrow-img.middle-left {\n  top: 25vh;\n  left: 0;\n  width: 50vw;\n  height: 50vh;\n}\n\n.arrow-img.middle-right {\n  top: 25vh;\n  right: 0;\n  width: 50vw;\n  height: 50vh;\n}\n\n.control-panel {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(255, 255, 255, 0.8);\n  padding: 1em;\n  border-radius: 10px;\n  text-align: center;\n  z-index: 2;\n}\n\n.color-buttons .circle {\n  width: 30px;\n  height: 30px;\n  margin: 0 5px;\n  border-radius: 50%;\n  border: none;\n  cursor: pointer;\n  margin-bottom: 8px;\n}\n\n.color-buttons .red { background: red; }\n.color-buttons .yellow { background: yellow; }\n.color-buttons .green { background: green; }\n.color-buttons .gray { background: gray; }\n\n.input-row input {\n  width: 80px;\n  margin: 0 5px;\n  padding: 5px;\n  font-size: 16px;\n  margin-bottom: 8px;\n}\n\n.action-buttons button {\n  font-size: 20px;\n  margin: 0 5px;\n  padding: 5px 10px;\n  cursor: pointer;\n}\n\n.action-buttons .active {\n  background-color: green;\n  color: white;\n}\n\n.frame-row {\n  display: flex;\n  gap: 2rem;\n  border: 2px solid #bbb;\n  border-radius: 10px;\n  padding: 1rem 2rem;\n  background: #f5f5f5;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.frame-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.frame-label {\n  font-size: 0.9rem;\n  color: #666;\n  margin-bottom: 0.3rem;\n}\n\n.frame-value {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #222;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
